export default "__VITE_ASSET__DjrSwLW6__"